import { ReactNode } from 'react';
import { useNavegate } from 'App/hooks';
import {
  CancelAndConfirmButtons,
  HeaderContent,
  HeaderTop,
  IonPageStratus,
} from 'commons/components';
import useTranslationShipping from 'domains/Shipping/useTranslationShipping';

interface ShippingPageProps {
  children: ReactNode;
  handleSave: () => void;
  title: string;
  isUpdating?: boolean;
  isError?: boolean;
  isLoading?: boolean;
  actions?: ReactNode;
  isConfirmDisabled?: boolean;
}
function ShippingPage({
  children,
  handleSave,
  title,
  isUpdating = false,
  isError = false,
  isLoading = false,
  actions,
  isConfirmDisabled = false,
}: ShippingPageProps) {
  const t = useTranslationShipping();

  const { goBack } = useNavegate();
  const backNavitation = {
    children: t('deliveryMethods.title'),
    onClick: goBack,
  };

  return (
    <IonPageStratus
      width="small"
      headerTop={<HeaderTop navigation={backNavitation} />}
      headerContent={<HeaderContent title={title} actions={actions} />}
    >
      {children}
      {!isLoading && !isError && (
        <CancelAndConfirmButtons
          isLoading={isUpdating}
          onCancel={goBack}
          onConfirm={handleSave}
          isConfirmDisabled={isConfirmDisabled}
          appearance={isConfirmDisabled ? 'neutral' : 'primary'}
        />
      )}
      {isLoading && !isError && <CancelAndConfirmButtons.Skeleton />}
    </IonPageStratus>
  );
}

export default ShippingPage;
